/** `PointerEvent.pointerType` */
export enum EPointerType {
  MOUSE = 'mouse',
  PEN = 'pen',
  TOUCH = 'touch',
}

/** `MouseEvent.button` */
export enum EMouseButton {
  MAIN = 0,
}
